import apps from "@services/applications";

export default [
  {
    path: "/app/gpsr",
    name: "gpsr",
    meta: {
      module: apps.Modules.Gpsr.Name,
      application: apps.Modules.Gpsr.Id,
      licenseName: "GPSR"
    },
    component: () => import("@Gpsr/views/Gpsr.vue"),
    children: []
  }
];
